/* eslint-disable no-undef */
import { DeleteModal, Dropdown, Menu } from 'components-antd';
import { ICON_VARIANT_TYPE, Icons } from 'pages/FormProcess/Icons';
import styles from './styles.module.scss';
import { Fragment, useMemo, useState } from 'react';
import { FormNotesModal } from '../../FormNotesModal';

type MenuOptionsType = { label: string; icon: JSX.Element; onClick: (e: any) => void };

export const NotesDropdown = (props) => {
  const [open, setOpen] = useState(false);
  const { signatory, onUpdateNote } = props;

  const [noteModal, setNoteModal] = useState(false);

  const onEditNote = (e) => {
    setOpen(false);
    toggleNoteModal();
  };

  const onDelete = (e) => {
    setOpen(false);
    onUpdateNote('');
  };

  const onAddPrivateNote = (e) => {
    setOpen(false);
    toggleNoteModal();
  };

  const getMenuOptions = () => {
    return signatory.note
      ? [
          {
            label: 'Edit Note',
            icon: <Icons variant={ICON_VARIANT_TYPE.RedNotes} />,
            onClick: onEditNote,
          },
          {
            label: 'Delete Note',
            icon: <Icons variant={ICON_VARIANT_TYPE.Trash} />,
            onClick: onDelete,
          },
        ]
      : [
          {
            label: 'Add Private Note',
            icon: <Icons variant={ICON_VARIANT_TYPE.RedNotes} />,
            onClick: onAddPrivateNote,
          },
        ];
  };

  const menu = () => {
    return (
      <Menu className={styles.formItemMenu} onClick={(e) => e.domEvent.stopPropagation()}>
        {getMenuOptions().map((item) => (
          <Menu.Item
            key={item.label}
            className={styles.action}
            onClick={item.onClick}
            icon={item.icon}
          >
            {item.label}
          </Menu.Item>
        ))}
      </Menu>
    );
  };

  const toggleNoteModal = () => {
    setNoteModal((prev) => !prev);
  };

  const onSaveSignerNote = (message) => {
    onUpdateNote(message);
    toggleNoteModal();
  };

  return (
    <Fragment>
      <Dropdown
        overlay={menu()}
        className={styles.dropdown}
        placement={'bottomRight'}
        trigger={['click']}
        onOpenChange={(visible) => setOpen(visible)}
      >
        <Icons
          className={styles.menuIcon}
          variant={open ? 'MenuDotsBg' : 'Dots_White_Bg'}
          onClick={(e) => e.stopPropagation()}
        />
      </Dropdown>

      <FormNotesModal
        isOpen={noteModal}
        editNoteInfo={signatory}
        defaultNote={signatory.note}
        onSaveNote={onSaveSignerNote}
        onClose={toggleNoteModal}
        signatories={[]}
      />
    </Fragment>
  );
};
